/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The AutoActionMail model module.
 * @module model/AutoActionMail
 * @version 1.0.0
 */
export default class AutoActionMail {
  /**
   * Constructs a new <code>AutoActionMail</code>.
   * @alias module:model/AutoActionMail
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>AutoActionMail</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AutoActionMail} obj Optional instance to populate.
   * @return {module:model/AutoActionMail} The populated <code>AutoActionMail</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AutoActionMail()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('auto_action_config_id')) {
        obj['auto_action_config_id'] = ApiClient.convertToType(data['auto_action_config_id'], 'Number')
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String')
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String')
      }
      if (data.hasOwnProperty('body')) {
        obj['body'] = ApiClient.convertToType(data['body'], 'String')
      }
      if (data.hasOwnProperty('mail_to')) {
        obj['mail_to'] = ApiClient.convertToType(data['mail_to'], 'String')
      }
      if (data.hasOwnProperty('smtp_setting_id')) {
        obj['smtp_setting_id'] = ApiClient.convertToType(data['smtp_setting_id'], 'Number')
      }
      if (data.hasOwnProperty('mail_reply_to')) {
        obj['mail_reply_to'] = ApiClient.convertToType(data['mail_reply_to'], 'String')
      }
      if (data.hasOwnProperty('mail_cc')) {
        obj['mail_cc'] = ApiClient.convertToType(data['mail_cc'], 'String')
      }
      if (data.hasOwnProperty('mail_bcc')) {
        obj['mail_bcc'] = ApiClient.convertToType(data['mail_bcc'], 'String')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {Number} auto_action_config_id
   */
  auto_action_config_id = undefined
  /**
   * @member {String} name
   */
  name = undefined
  /**
   * @member {String} title
   */
  title = undefined
  /**
   * @member {String} body
   */
  body = undefined
  /**
   * @member {String} mail_to
   */
  mail_to = undefined
  /**
   * @member {Number} smtp_setting_id
   */
  smtp_setting_id = undefined
  /**
   * @member {String} mail_reply_to
   */
  mail_reply_to = undefined
  /**
   * @member {String} mail_cc
   */
  mail_cc = undefined
  /**
   * @member {String} mail_bcc
   */
  mail_bcc = undefined
}
